// extracted by mini-css-extract-plugin
export var active = "SwipeGallery-module--active--b25ab";
export var circle = "SwipeGallery-module--circle--9388a";
export var sliderCircleContent = "SwipeGallery-module--sliderCircleContent--6c9a6";
export var touchStart = "SwipeGallery-module--touchStart--7368b";